import { render, staticRenderFns } from "./PictureComp.vue?vue&type=template&id=66c272cd&scoped=true"
import script from "./PictureComp.vue?vue&type=script&setup=true&lang=ts"
export * from "./PictureComp.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./PictureComp.vue?vue&type=style&index=0&id=66c272cd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66c272cd",
  null
  
)

export default component.exports